export default __webpack_public_path__ + "static/media/giftLanding.f59f0247.webp";